// HelpOverlay.tsx
import React from 'react'
import { useHelp } from './HelpProvider'

const HelpOverlay = () => {
  const { currentStep } = useHelp()

  if (currentStep === null) return null

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // semi-transparent dark
        zIndex: 1200, // lower than your popover/navigation box (which are 1300-1400)
        pointerEvents: 'none', // very important: allow clicks through
      }}
    />
  )
}

export default HelpOverlay
